"use client";

import React from "react";
import { Wallet, Users, Trophy } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
const steps = [{
  title: "CONSULTATION",
  description: "We meet on-site to discuss your vision, assess the terrain, and define the project scope.",
  icon: Wallet
}, {
  title: "DESIGN PHASE",
  description: "Our experts craft a detailed landscape plan, selecting premium materials and native flora.",
  icon: Users
}, {
  title: "INSTALLATION",
  description: "Our elite crew brings the design to life with precision masonry and expert planting.",
  icon: Trophy
}];
export default function CicloDeAjudaMutua() {
  return <section data-section-id="222498" id="landscapingworkflow" className="py-24 bg-background text-foreground relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-primary font-default uppercase tracking-wider">
            OUR ELITE PROCESS
          </h2>
        </div>

        <div className="relative z-0">
          {}
          <div className="hidden md:block absolute top-16 left-[16.66%] right-[16.66%] h-[2px] border-t-2 border-dashed border-secondary/30 -z-10" aria-hidden="true" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {steps.map((step, i) => <div data-index={i} key={i} className="h-full">
                <Card className="h-full bg-primary rounded-lg shadow-lg transition-transform duration-300 hover:-translate-y-2 border-none flex flex-col items-center text-center pt-8">
                  <CardHeader className="pt-0 pb-4 flex flex-col items-center">
                    <div className="w-16 h-16 rounded-lg bg-secondary/10 flex items-center justify-center text-secondary mb-6 shadow-sm">
                      <step.icon className="w-8 h-8" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="text-xl font-semibold text-primary-foreground font-default">
                      {step.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-base text-primary-foreground/80 font-default">
                      {step.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </div>)}
          </div>

          <div className="mt-16 flex justify-center">
            <Link to="https://companycam.com" newTab className="inline-flex items-center justify-center px-8 py-4 bg-secondary text-secondary-foreground font-bold rounded-lg shadow-md hover:scale-105 transition-all duration-300 uppercase tracking-wide text-sm md:text-base">
              Follow our live project updates on CompanyCam
            </Link>
          </div>
        </div>
      </div>
    </section>;
}